// extracted by mini-css-extract-plugin
export default {"root":"BlankStateSection__root--bpzxA","column":"BlankStateSection__column--V_jpg","left":"BlankStateSection__left--f9b_C","right":"BlankStateSection__right--zY3Zb"};